<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useUserStore } from "@/App/user/user.store";

const userStore = useUserStore();
const { user } = storeToRefs(userStore);
</script>

<template>
  <div class="text-name">
    <span>
      <span class="icon fa-solid fa-fw fa-user" />
      <span>{{ user?.displayName }}</span>
    </span>
  </div>
</template>

<style lang="scss" scoped>
.text-name {
  color: white;
}
@media (max-width: 60rem) {
  .fa-user {
    display: none;
  }
}
</style>
